import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@auth';
import { of, switchMap } from 'rxjs';

export const AnonymousGuard: CanActivateFn = (_: ActivatedRouteSnapshot) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  return authStore.isAuthenticated$.pipe(switchMap(isAuth => of(isAuth ? router.createUrlTree(['/']) : true)));
};
